import styles from './Badge.module.css';

/**
 * Small pill label.
 *
 * tone: 'high' | 'med' | 'low' | 'sport' | 'pro' | 'win' | 'loss' | 'live' | 'info'
 * dot:  show the leading status dot ('live' pulses on its own)
 */
export function Badge({ tone = 'low', dot = false, className = '', children, ...rest }) {
  const classes = [styles.badge, styles[tone], className].filter(Boolean).join(' ');
  return (
    <span className={classes} {...rest}>
      {dot && <span className={styles.dot} />}
      {children}
    </span>
  );
}

/**
 * The pulsing "LIVE" pill. Same visual language as Badge tone="live", but it
 * always carries the animated dot.
 */
export function LiveBadge({ className = '', children = 'LIVE', ...rest }) {
  return (
    <span className={`${styles.badge} ${styles.live} ${className}`} {...rest}>
      <span className={styles.dot} />
      {children}
    </span>
  );
}
